import { render, staticRenderFns } from "./Odontogram.vue?vue&type=template&id=2750feb0&"
import script from "./Odontogram.vue?vue&type=script&lang=js&"
export * from "./Odontogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports